export default "__VITE_ASSET__defa7bac__"